import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as locales from '@alveon/shared/locales';

// Все 35 языков из shared (единый источник с mobile)
const resources = {
  ar: { translation: locales.ar },
  be: { translation: locales.be },
  ca: { translation: locales.ca },
  cs: { translation: locales.cs },
  da: { translation: locales.da },
  de: { translation: locales.de },
  el: { translation: locales.el },
  en: { translation: locales.en },
  es: { translation: locales.es },
  fi: { translation: locales.fi },
  fr: { translation: locales.fr },
  he: { translation: locales.he },
  hi: { translation: locales.hi },
  hr: { translation: locales.hr },
  hu: { translation: locales.hu },
  id: { translation: locales.id },
  it: { translation: locales.it },
  ja: { translation: locales.ja },
  kk: { translation: locales.kk },
  ko: { translation: locales.ko },
  ms: { translation: locales.ms },
  nb: { translation: locales.nb },
  nl: { translation: locales.nl },
  pl: { translation: locales.pl },
  pt: { translation: locales.pt },
  ro: { translation: locales.ro },
  ru: { translation: locales.ru },
  sk: { translation: locales.sk },
  sv: { translation: locales.sv },
  th: { translation: locales.th },
  tr: { translation: locales.tr },
  uk: { translation: locales.uk },
  vi: { translation: locales.vi },
  'zh-Hans': { translation: locales.zhHans },
  'zh-Hant': { translation: locales.zhHant },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ru', // Язык по умолчанию
    fallbackLng: 'en', // Единый fallback, как в мобильном
    interpolation: {
      escapeValue: false, // React уже защищает от XSS
    },
    // Поддержка плюрализации для русского языка
    pluralSeparator: '_',
  });

export default i18n;

